import * as React from 'react'
import classNames from 'classnames'

import { Pill } from 'sdk/pill/Pill'

import classes from './style.module.scss'

interface ComponentProps {
  pillText: string
  pillIcon: string
  titleText: string
  alignment?: 'center' | 'left'
}

export const HeroTitle: React.FC<ComponentProps> = ({
  pillText,
  pillIcon,
  titleText,
  alignment = 'center',
}) => {
  return (
    <div className={classNames(classes.heroTitle, classes[alignment])}>
      <Pill 
        text={pillText} 
        icon={pillIcon} 
        variant="gradient" 
      />
      <span className={classes.title}>{titleText}</span>
    </div>
  )
}